<template>
  <div>
    <div class="px-5 pt-2 pb-5">
      <div class="row">
        <div class="btn-home col-md-12 mt-3 mb-4 d-flex justify-content-end">
          <button type="button" class="btn btn-outline-main" @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>

      <div id="div-modal-compra" class="w-100">
        <div class="row">
          <div class="col-md-3">
            <div id="div-compra" class="card w-100 mb-4">
              <div class="text-center card-header text-white h4 bg-main">
                <strong>DATOS DE COMPRA</strong>
              </div>
              <div class="card-body" style="background-color: #f2f4f4">
                <div class="row g-3">
                  <div class="col-xl-12 col-lg-12 col-md-12">
                    <label class="form-label">Proveedor</label>
                    <v-select :options="dataProviders" class="bg-white" label="name" :reduce="(provider) => provider.id"
                      placeholder="Seleccione un proveedor..." v-model="cabecera.provider_id"
                      @input="mtdSelectProvider" />
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-12">
                    <label class="form-label">Fecha</label>
                    <input type="date" class="form-control inpunt-rounded" v-model="cabecera.date" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6">
                    <label class="form-label">Serie</label>
                    <input type="text" class="form-control inpunt-rounded" v-model="cabecera.document_serie"
                      placeholder="Serie" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6">
                    <label class="form-label">Número</label>
                    <input type="text" class="form-control inpunt-rounded" v-model="cabecera.document_number"
                      placeholder="Número" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6">
                    <label class="form-label d-block">Forma de pago</label>
                    <div class="doc-toggle">
                      <label class="doc-toggle__option"
                        :class="{ 'doc-toggle__option--active': cabecera.payment_type == 'contado' }">
                        <input type="radio" value="contado" v-model="cabecera.payment_type" />
                        <span>Contado</span>
                      </label>
                      <label class="doc-toggle__option"
                        :class="{ 'doc-toggle__option--active': cabecera.payment_type == 'credito' }">
                        <input type="radio" value="credito" v-model="cabecera.payment_type" />
                        <span>Crédito</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6" v-if="cabecera.payment_type == 'credito'">
                    <label class="form-label">Días de crédito</label>
                    <input type="text" class="form-control inpunt-rounded" v-model="cabecera.credit_days"
                      @keypress="isNumber" placeholder="Días de crédito" />
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-12">
                    <label class="form-label d-block">¿Viene con guía?</label>
                    <div class="input-group input-group-sm">
                      <div class="input-group-text">
                        <input class="form-check-input mt-0" type="checkbox" v-model="cabecera.has_guide"
                          aria-label="Checkbox for following text input" />&nbsp;{{ cabecera.has_guide ? "Sí" : "No" }}
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-12" v-if="cabecera.has_guide">
                    <label class="form-label">N° de Guía</label>
                    <input type="text" class="form-control inpunt-rounded" v-model="cabecera.guide_number"
                      placeholder="N° de guía de remisión" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <div id="div-detalle" class="card w-100 mb-4">
              <div class="text-center card-header text-white h4 bg-main">
                <strong>DETALLE DE LA COMPRA</strong>
              </div>
              <div class="card-body" style="background-color: #f2f4f4">
                <div class="input-group input-group-sm mb-2">
                  <span class="input-group-text text-white bg-main"><i class="fas fa-search"></i></span>
                  <input type="text" class="form-control" v-model="search_product" @keyup.enter="mtdSearchProducts"
                    :disabled="!cabecera.provider_id"
                    placeholder="Buscar por código / nombre / molécula / comercial / marca..." />
                  <button class="btn btn-bm" type="button" :disabled="!cabecera.provider_id" @click="mtdSearchProducts">
                    Buscar
                  </button>
                </div>
                <div v-if="!cabecera.provider_id" class="text-danger text-xs mb-2">
                  Seleccione un proveedor para poder buscar sus productos.
                </div>

                <div v-if="dataProductos.length > 0" class="mb-3" style="max-height: 180px; overflow-y: auto">
                  <table class="table table-sm table-bordered border-main text-center mb-0">
                    <caption class="py-0 my-0"></caption>
                    <thead class="bg-main text-white">
                      <tr>
                        <th>Molécula</th>
                        <th>Código</th>
                        <th>Comercial</th>
                        <th>Marca</th>
                        <th>Presentación</th>
                        <th>P. Compra</th>
                        <th>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in dataProductos" :key="index">
                        <td>{{ item.molecule }}</td>
                        <td>{{ item.code || "-" }}</td>
                        <td>{{ item.commercial }}</td>
                        <td>{{ item.brand || "-" }}</td>
                        <td>{{ item.presentation }}</td>
                        <td>S/ {{ parseFloat(item.precio_purchase || 0).toFixed(2) }}</td>
                        <td>
                          <button type="button" class="btn btn-sm btn-success" @click="mtdAddItem(item)">
                            <i class="fas fa-plus"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-bordered border-main align-middle text-center">
                    <caption class="py-0 my-0"></caption>
                    <thead class="bg-main text-white">
                      <tr>
                        <th>N°</th>
                        <th>Código</th>
                        <th>Producto</th>
                        <th>Lote</th>
                        <th>F. Vencimiento</th>
                        <th>Unidad</th>
                        <th>Cantidad</th>
                        <th>P. Unit</th>
                        <th>Subtotal</th>
                        <th>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="carrito.length == 0">
                        <td colspan="10">No hay productos agregados</td>
                      </tr>
                      <tr v-for="(item, index) in carrito" :key="index"
                        :class="isRowValid(item) ? 'row-valid' : 'row-invalid'">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.code || "-" }}</td>
                        <td class="text-start">{{ item.molecule }} - {{ item.commercial }}</td>
                        <td>
                          <input type="text" class="form-control form-control-sm" v-model="item.lote" />
                        </td>
                        <td>
                          <input type="date" class="form-control form-control-sm" v-model="item.due_date" />
                        </td>
                        <td>
                          <select class="form-control form-control-sm" v-model="item.unit_id">
                            <option v-for="(unit, i) in item.units" :key="i" :value="unit.unit_id">
                              {{ unit.unit.name }}
                            </option>
                          </select>
                        </td>
                        <td>
                          <input type="text" class="form-control form-control-sm" style="width: 70px"
                            v-model="item.quantity" @keypress="isDecimal" @input="mtdCalculateSubtotal(item)" />
                        </td>
                        <td>
                          <input type="text" class="form-control form-control-sm" style="width: 80px"
                            v-model="item.price" @keypress="isDecimal" @input="mtdCalculateSubtotal(item)" />
                        </td>
                        <td>S/ {{ parseFloat(item.subtotal || 0).toFixed(2) }}</td>
                        <td>
                          <button type="button" class="btn btn-sm btn-danger" @click="mtdRemoveItem(index)">
                            <i class="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row justify-content-end mt-2">
                  <div class="col-md-4">
                    <div class="d-flex justify-content-between">
                      <strong>Op. Gravada</strong>
                      <span>S/ {{ cpSubtotal.toFixed(2) }}</span>
                    </div>
                    <div class="d-flex justify-content-between">
                      <strong>IGV (18%)</strong>
                      <span>S/ {{ cpIgv.toFixed(2) }}</span>
                    </div>
                    <hr class="my-1" />
                    <div class="d-flex justify-content-between h5">
                      <strong>TOTAL</strong>
                      <strong>S/ {{ cpTotal.toFixed(2) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer text-end bg-white">
                <button type="button" class="btn btn-bm px-4" @click="mtdRegistrarCompra">
                  <i class="fas fa-save"></i> Registrar Compra
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
  name: "c-logistica-pages-purchasenew",
  components: {
    SweetAlert,
  },
  data() {
    return {
      swal: null,
      cabecera: {
        provider_id: null,
        provider_ruc: "",
        date: new Date().toISOString().split("T")[0],
        document_serie: "",
        document_number: "",
        payment_type: "contado",
        credit_days: null,
        has_guide: false,
        guide_number: "",
      },
      dataProviders: [],
      search_product: "",
      dataProductos: [],
      carrito: [],
    };
  },
  computed: {
    cpTotal() {
      return this.carrito.reduce((acc, item) => acc + parseFloat(item.subtotal || 0), 0);
    },
    cpSubtotal() {
      return this.cpTotal / 1.18;
    },
    cpIgv() {
      return this.cpTotal - this.cpSubtotal;
    },
  },
  created() {
    this.mtdGetProviders();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    mtdGetProviders: function () {
      this.get({
        url: this.$store.getters.get__url + "/logistics/maintenance/provider",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataProviders = response.data;
        })
        .catch((errors) => { });
    },
    mtdSelectProvider: function (providerId) {
      const provider = this.dataProviders.find((p) => p.id == providerId);
      this.cabecera.provider_ruc = "";
      this.cabecera.credit_days = provider ? provider.credit_days : null;
      this.dataProductos = [];
      this.carrito = [];
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isDecimal: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdSearchProducts: function () {
      if (!this.cabecera.provider_id) {
        return;
      }
      const provider = this.dataProviders.find((p) => p.id == this.cabecera.provider_id);
      this.post({
        url: this.$store.getters.get__url + "/ordendecompra/detalles/filter",
        token: this.$store.getters.get__token,
        params: {
          molecula: this.search_product,
          proveedor: "",
          ruc: "",
        },
      })
        .then((response) => {
          this.dataProductos = response.data || [];
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdAddItem: function (item) {
      const exists = this.carrito.some((el) => el.id == item.id);
      if (exists) {
        this.$refs.SweetAlert.showWarning("El producto ya fue agregado");
        return;
      }
      const quantity = 1;
      const price = parseFloat(item.precio_purchase || 0);
      this.carrito.push({
        id: item.id,
        code: item.code || null,
        molecule: item.molecule,
        commercial: item.commercial,
        brand: item.brand,
        presentation: item.presentation,
        units: item.units || [],
        unit_id: item.units && item.units.length > 0 ? item.units[0].unit_id : null,
        lote: "",
        due_date: "",
        quantity,
        price,
        subtotal: quantity * price,
      });
      this.dataProductos = [];
      this.search_product = "";
    },
    mtdCalculateSubtotal: function (item) {
      const quantity = parseFloat(item.quantity) || 0;
      const price = parseFloat(item.price) || 0;
      item.subtotal = quantity * price;
    },
    mtdRemoveItem: function (index) {
      this.carrito.splice(index, 1);
    },
    /**
     * Valida una fila del carrito
     */
    isRowValid: function (item) {
      const isLoteValid = this.isLoteValid(item.lote);
      const isDateValid = this.isValidDate(item.due_date);
      const quantity = parseFloat(item.quantity);
      const isQuantityValid = !isNaN(quantity) && quantity > 0;
      const price = parseFloat(item.price);
      const isPriceValid = !isNaN(price) && price > 0;

      return isLoteValid && isDateValid && isQuantityValid && isPriceValid;
    },
    isLoteValid: function (value) {
      if (value === null || value === undefined) return false;
      return String(value).trim().length > 0;
    },
    isValidDate: function (value) {
      if (!value) return false;
      const date = new Date(value);
      if (isNaN(date.getTime())) return false;
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      return regex.test(value);
    },
    mtdRegistrarCompra: function () {
      if (!this.cabecera.provider_id) {
        this.$refs.SweetAlert.showWarning("Seleccione un proveedor");
        return;
      }
      if (!this.cabecera.document_serie || !this.cabecera.document_number) {
        this.$refs.SweetAlert.showWarning("Ingrese la serie y el número de documento");
        return;
      }
      if (this.cabecera.has_guide && !this.cabecera.guide_number) {
        this.$refs.SweetAlert.showWarning("Ingrese el número de guía");
        return;
      }
      if (this.carrito.length == 0) {
        this.$refs.SweetAlert.showWarning("Agregue al menos un producto");
        return;
      }

      // Validación por fila antes de registrar
      for (let i = 0; i < this.carrito.length; i++) {
        const item = this.carrito[i];
        if (!this.isLoteValid(item.lote)) {
          this.$refs.SweetAlert.showWarning(`Fila ${i + 1}: ingrese el lote`);
          return;
        }
        if (!this.isValidDate(item.due_date)) {
          this.$refs.SweetAlert.showWarning(`Fila ${i + 1}: la fecha de vencimiento no es válida`);
          return;
        }
        const quantity = parseFloat(item.quantity);
        if (isNaN(quantity) || quantity <= 0) {
          this.$refs.SweetAlert.showWarning(`Fila ${i + 1}: la cantidad debe ser mayor a cero`);
          return;
        }
        const price = parseFloat(item.price);
        if (isNaN(price) || price <= 0) {
          this.$refs.SweetAlert.showWarning(`Fila ${i + 1}: el precio unitario debe ser mayor a cero`);
          return;
        }
      }

      this.post({
        url: this.$store.getters.get__url + "/logistics/compra/store",
        token: this.$store.getters.get__token,
        params: {
          provider_id: this.cabecera.provider_id,
          date: this.cabecera.date,
          document_serie: this.cabecera.document_serie,
          document_number: this.cabecera.document_number,
          payment_type: this.cabecera.payment_type,
          credit_days: this.cabecera.payment_type == "credito" ? this.cabecera.credit_days : null,
          has_guide: this.cabecera.has_guide,
          guide_number: this.cabecera.has_guide ? this.cabecera.guide_number : null,
          detail: this.carrito,
          subtotal: this.cpSubtotal,
          igv: this.cpIgv,
          total: this.cpTotal,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.$refs.SweetAlert.showSuccess(response.message || "Compra registrada correctamente");
            this.mtdReset();
          }
        })
        .catch((errors) => {
          console.log(errors);
          this.$refs.SweetAlert.showWarning(
            errors?.response?.data?.message ?? "Ocurrió un error al registrar la compra"
          );
        });
    },
    mtdReset: function () {
      this.cabecera = {
        provider_id: null,
        provider_ruc: "",
        date: new Date().toISOString().split("T")[0],
        document_serie: "",
        document_number: "",
        payment_type: "contado",
        credit_days: null,
        has_guide: false,
        guide_number: "",
      };
      this.search_product = "";
      this.dataProductos = [];
      this.carrito = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.doc-toggle {
  display: inline-flex;
  border: 1px solid #dcdce0;
  border-radius: 50px;
  overflow: hidden;
  background-color: #ffffff;
}

.doc-toggle__option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  margin: 0;
  cursor: pointer;
  font-weight: 500;
  color: #8a8a97;
  transition: background-color 0.15s ease, color 0.15s ease;
  user-select: none;
}

.doc-toggle__option input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.doc-toggle__option--active {
  background-color: #900052;
  color: #fff;
}

.doc-toggle__option:not(.doc-toggle__option--active):hover {
  background-color: #eceef1;
}

/* Colores de estado por fila */
.row-valid > td {
  background-color: #d4edda !important; /* verde claro */
}

.row-invalid > td {
  background-color: #f8d7da !important; /* rojo claro */
}
</style>